const KEY = "meucontroleai:device-id"
const VALID = /^[A-Za-z0-9-]{8,64}$/

function randomId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID()
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
}

/** A random id kept in this browser so the server can cap prize draws per device; undefined when storage is unavailable. */
export function storefrontDeviceId(): string | undefined {
  try {
    const stored = localStorage.getItem(KEY)
    if (stored && VALID.test(stored)) return stored
    const created = randomId()
    localStorage.setItem(KEY, created)
    return created
  } catch {
    return undefined
  }
}
